"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.firstNonNullable = exports.isArray = exports.makeNonNullableArray = exports.hasIntersection = exports.removeFromDistinctArray = exports.addToDistinctArray = exports.distinctArray = exports.removeItemAll = exports.removeItemOnce = void 0;
const removeItemOnce = (arr, value) => {
    const index = arr.indexOf(value);
    if (index > -1) {
        arr.splice(index, 1);
    }
    return arr;
};
exports.removeItemOnce = removeItemOnce;
const removeItemAll = (arr, value) => {
    let i = 0;
    while (i < arr.length) {
        if (arr[i] === value) {
            arr.splice(i, 1);
        }
        else {
            ++i;
        }
    }
    return arr;
};
exports.removeItemAll = removeItemAll;
const distinctArray = (arr) => [...new Set(arr)];
exports.distinctArray = distinctArray;
const addToDistinctArray = (arr, value) => (0, exports.distinctArray)([...arr, value]);
exports.addToDistinctArray = addToDistinctArray;
const removeFromDistinctArray = (arr, value) => (0, exports.removeItemOnce)((0, exports.distinctArray)(arr), value);
exports.removeFromDistinctArray = removeFromDistinctArray;
/**
 * If any value in array 'a' exists in array 'b'
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const hasIntersection = (a, b) => {
    return !!a.find((v) => b.includes(v));
};
exports.hasIntersection = hasIntersection;
const makeNonNullableArray = (x) => {
    const maybeXArr = Array.isArray(x) ? x : [x];
    return maybeXArr.filter((v) => { var _a; return (_a = !!v) !== null && _a !== void 0 ? _a : false; });
};
exports.makeNonNullableArray = makeNonNullableArray;
const isArray = (x) => {
    return Array.isArray(x);
};
exports.isArray = isArray;
const firstNonNullable = (x) => {
    return (0, exports.makeNonNullableArray)(x)[0];
};
exports.firstNonNullable = firstNonNullable;
